// Accented letters for the kid keyboard (Alan, 1 Oct: "add foreign language accents to the
// keyboard? Same gesture as Apple keyboard - hold down to show list"). Which letters a long press
// offers, per homework language (HW_LANGUAGES in lib/homework.js), in the order a child is most
// likely to want them. A letter missing from a language's map has no accents there, so holding it
// does nothing but type it. An unknown language (the parent typed one we have no list for) gets
// every accent the five known ones use, which is what a phone's own keyboard does.
//
// Marking never needed these: normaliseAnswer strips accents, so "elephant" is right for
// "éléphant". They are here so a child can write the word as the sheet writes it.
//
// No React, no imports: same posture as lib/content.js, safe anywhere.

export const ACCENTS = {
  French: { a: ["à", "â", "æ"], e: ["é", "è", "ê", "ë"], i: ["î", "ï"], o: ["ô", "œ"], u: ["ù", "û", "ü"], c: ["ç"], y: ["ÿ"] },
  Spanish: { a: ["á"], e: ["é"], i: ["í"], o: ["ó"], u: ["ú", "ü"], n: ["ñ"] },
  German: { a: ["ä"], o: ["ö"], u: ["ü"], s: ["ß"] },
  Italian: { a: ["à"], e: ["è", "é"], i: ["ì", "í"], o: ["ò", "ó"], u: ["ù", "ú"] },
  // Latin sheets mark long vowels with a macron (amō, puella → puellā), when they mark them at all.
  Latin: { a: ["ā"], e: ["ē"], i: ["ī"], o: ["ō"], u: ["ū"], y: ["ȳ"] },
};

// Every language's accents together, each letter's list de-duplicated in first-seen order.
const ALL = (() => {
  const out = {};
  for (const map of Object.values(ACCENTS)) {
    for (const [k, list] of Object.entries(map)) out[k] = [...new Set([...(out[k] || []), ...list])];
  }
  return out;
})();

// The accents for a list's language: the named language when we know it, case-insensitively,
// otherwise every accent we know.
export function accentsFor(lang) {
  const name = String(lang || "").trim().toLowerCase();
  const hit = Object.keys(ACCENTS).find((l) => l.toLowerCase() === name);
  return hit ? ACCENTS[hit] : ALL;
}
